import { MoreVert } from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, MenuList } from "@mui/material";
import { datatypes, inputTypes } from "data/globalData";
import { useState } from "react";

export const lsModalProfileFilterValStr = "modal_profile_table_filter_obj";

export const shootSkuItemMasterColumns = {
	brand: {
		name: "Brand",
		key: "brand",
		bqColumn: "BRAND",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	sub_brand: {
		name: "Sub Brand",
		key: "sub_brand",
		bqColumn: "SUB_BRAND",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	division: {
		name: "Division",
		key: "division",
		bqColumn: "DIVISION",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	season: {
		name: "Season",
		key: "season",
		bqColumn: "SEASON",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	category: {
		name: "Category",
		key: "category",
		bqColumn: "DEPARTMENT",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	sub_category: {
		name: "Sub Category",
		key: "sub_category",
		bqColumn: "PATTERN",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	style_name: {
		name: "Style Name",
		key: "style_name",
		bqColumn: "STYLE",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	color: {
		name: "Color",
		key: "color",
		bqColumn: "COLOR",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	pallete: {
		name: "Pallete",
		key: "pallete",
		bqColumn: "COLOR",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	size: {
		name: "Size",
		key: "size",
		bqColumn: "SIZE",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	fashionability: {
		name: "Fashionability",
		key: "fashionability",
		bqColumn: "FASHIONABILITY",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
};
export const shootMerchantSampleDetailsColumns = {
	planned_sample_date: {
		name: "Planned Sample Handover",
		key: "planned_sample_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	sample_ready_date: {
		name: "Sample Ready Date",
		key: "sample_ready_date",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 2,
		group: "",
		placeholder: "",
		default_value: "",
	},
	expected_production_inward: {
		name: "Expected Production Inward",
		key: "expected_production_inward",
		bqColumn: "DIVISION",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	vendor_name: {
		name: "Vendor Name",
		key: "vendor_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	cost: {
		name: "Cost",
		key: "cost",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DECIMAL.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	merchant_remarks: {
		name: "Merchant Remarks",
		key: "merchant_remarks",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
};

export const merchantUpdatedByColumn = {
	name: "Merchant Updated By",
	key: "merchant_updated_by",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 99,
	group: "",
	placeholder: "",
	default_value: "",
};

export const shootSkuIcodeColumn = {
	name: "ICODE",
	key: "i_code",
	bqColumn: "ICODE",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
};
export const shootMerchantSampleImgUrlCol = {
	name: "Sample Handover Image",
	key: "handover_img_url",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
};
export const shootStudioSampleImgUrlCol = {
	name: "Sample Inward Image",
	key: "inward_img_url",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
};

export const shootStudioSampleDetailsColumns = {
	sample_inward_date: {
		name: "Sample Inward Date",
		key: "sample_inward_date",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},

	ginesys_code: {
		name: "Ginesys Code",
		key: "ginesys_code",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},
	studio_remarks: {
		name: "Studio Remarks",
		key: "studio_remarks",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
	},
};

export const studioUpdatedByColumn = {
	name: "Studio Updated By",
	key: "studio_updated_by",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 99,
	group: "",
	placeholder: "",
	default_value: "",
};

export const sampleStatusColumn = {
	name: "Status",
	key: "status",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
};

const ActionCell = ({ row, actionList }) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleOpen = (e) => {
		setAnchorEl(e.currentTarget);
		e.stopPropagation();
	};
	const handleClose = () => setAnchorEl(null);

	return (
		<>
			<IconButton onClick={handleOpen}>
				<MoreVert />
			</IconButton>

			<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
				{actionList.map((action) => (
					<MenuItem
						key={action.name}
						onClick={(e) => {
							e.stopPropagation();
							action.onClick(row);
							handleClose();
						}}>
						{action.name}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export const shootSkuActionDgCol = (actionList) => {
	return {
		headerName: "Actions",
		minWidth: 80,
		headerAlign: "center",
		align: "center",
		flex: 1,
		renderCell: (params) => {
			return (
				<Box width="100%" display="flex" alignItems="center" justifyContent="center">
					<ActionCell row={params.row} actionList={actionList} />
				</Box>
			);
		},
	};
};
